const { get, some, isUndefined } = require('lodash');

class DeliverySaverPlanGroupController {
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.planInclusions = get(this.plans, '[0].Metadata.Inclusions', []);
        this.disclaimer = get(this.plans, '[0].Metadata.Disclaimer');

        if (isUndefined(this.isPlanGroupDisabled)) {
            this.isPlanGroupDisabled = false;
        }
    }

    isSelectedPlanInGroup() {
        return some(this.plans, p => p.Id === this.selectedPlanId);
    }

    isSubscribeDisabled() {
        return this.isPlanGroupDisabled || !this.isSelectedPlanInGroup();
    }

    selectDeliverySaverPlan() {
        this.$state.go('shop.deliveryplus.paymentsetup', { planId: this.selectedPlanId });
    }

    getSelectedPlan() {
        return this.plans.find(x => x.Id === this.selectedPlanId);
    }
}

DeliverySaverPlanGroupController.$inject = ['$state'];

const DeliverySaverPlanGroupComponentDefinition = {
    controller: DeliverySaverPlanGroupController,
    template: require('./delivery-saver-plan-group.component.html').trim(),
    bindings: {
        groupHeading: '@',
        isPlanGroupDisabled: '<',
        plans: '<',
        selectedPlanId: '=',
    },
};

module.exports = {
    DeliverySaverPlanGroupComponentDefinition,
    DeliverySaverPlanGroupController,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/plangroup/delivery-saver-plan-group.component.js